import { userHasGlobalScope } from "../../auth/scopes.ts";
import { useAuth } from "../../contexts/AuthContext.tsx";

/**
 * Whether the user may read agent transcripts (tool calls, raw tool results):
 * developers only, as the transcript endpoints enforce.
 */
export function useCanSeeTranscripts(): boolean {
  const { user } = useAuth();
  return userHasGlobalScope(user, "dev:read");
}
